// Contracts and fall leases components
import { defineAsyncComponent } from 'vue'

export default {
  ContractsAdminTable: defineAsyncComponent(
    () => import('../contracts/contracts_admin_table.vue')
  ),
  ContractsEdit: defineAsyncComponent(() => import('../contracts/edit.vue')),
  FallLeaseContractsTable: defineAsyncComponent(
    () => import('../fall_leases/fall_lease_contracts_table.vue')
  ),
  FallLeases: defineAsyncComponent(() => import('../fall_leases/show.vue')),
  FallLeasesEdit: defineAsyncComponent(() => import('../fall_leases/edit.vue'))
}
